/* eslint-disable @typescript-eslint/explicit-function-return-type */
import routeNames from '@/router/routeNames'

import type { StrictRouteConfig } from 'types/router'

const AgencyLayout = () => import('@/layouts/AgencyLayout.vue')
const AgencyListPage = () => import('@/pages/Agency/AgencyListPage.vue')
const AgencyDetailPage = () => import('@/pages/Agency/AgencyDetailPage.vue')
const MyAgenciesPage = () => import('@/pages/Agency/MyAgenciesPage.vue')

const routeConfig: StrictRouteConfig[] = [
  {
    path: '/agency',
    meta: { requiresAuth: true, title: 'Agencies' },
    component: AgencyLayout,
    children: [
      {
        path: '',
        name: routeNames.AGENCY_LIST,
        component: AgencyListPage,
        meta: { title: 'Agencies' },
      },
      {
        path: '/user',
        name: routeNames.MY_AGENCIES,
        component: MyAgenciesPage,
        meta: { title: 'My Agencies' },
      },
      {
        path: ':id',
        name: routeNames.AGENCY_DETAIL,
        component: AgencyDetailPage,
        meta: { onBack: '-1' },
      },
    ],
  },
]

export default routeConfig
